import { Pipe, PipeTransform } from '@angular/core';
import { Pendiente } from '../../models/pendiente';

@Pipe({
    name: 'notasPendiente' // nombre del pipe en las directivas
})

export class NotasPendientePipe implements PipeTransform {
    // Métdodo a implementar siempre
    transform(pendiente:Pendiente){
        // Se inicializa un arreglo vacío
        let notas:Array<any> = [];
        
        // Checa si existe el pendiente
        if(pendiente){
            // Hace un loop por las notas
            for(let idNota in pendiente.notas){
                notas.push(pendiente.notas[idNota]);
            }
        }
        return notas;
    }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/notas-pendientes.pipe.ts